<div class="text-collapse-container" [class.expanded]="isExpanded">
  <div #clipWrapper class="text-collapse-clip">
    <div
      #contentHost
      class="text-collapse-content paragraph ql-editor"
      [innerHTML]="displayContent"
    ></div>
  </div>
  <div *ngIf="showToggle" class="text-collapse-toggle-wrapper">
    <button
      class="text-collapse-toggle"
      (click)="toggleExpanded()"
      [disabled]="animationInProgress"
      type="button"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-label]="(isExpanded ? 'showLess' : 'showMore') | translate"
    >
      {{ (isExpanded ? 'showLess' : 'showMore') | translate }}
    </button>
  </div>
</div>
